/**
 *
 * @Copyright 2025 UNLOCKIT DECENTRALIZATION, LDA
 *
 */

export const MAXIMUM_FILE_SIZE_MB = 50;
